import type { OptionType } from '@/api/common';
import { Text, type TextProps } from '@/components/typography';

type Props = TextProps & {
  options: (OptionType | { value: number; label: string })[];
};

/**
 * Used to display the label of an option from a list of options. This is particularly useful for
 * displaying a read-only text value from a component with options such as Select or Radio.Group.
 */
const MultiOptionText = ({ options, value, ...rest }: Props) => {
  const option = options.find((option) => {
    if ('value' in option) {
      return option.value === value;
    }
    return 'id' in option && option.id === value;
  });

  if (option && 'label' in option) {
    return <Text {...rest}>{option.label}</Text>;
  }
  if (option && 'name' in option) {
    return <Text {...rest}>{option.name}</Text>;
  }
  return null;
};

export default MultiOptionText;
